export enum JOBTYPES {
    APBS = 'apbs',
    PDB2PQR = 'pdb2pqr',
}